/**
 * @fileoverview
 * Authentication Guard - Protects routes that require authentication
 * 
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService, TokenService } from '../services';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  // Check both signal state and token existence/validity
  const hasToken = tokenService.hasToken() && !tokenService.isTokenExpired();
  const isAuthenticated = authService.isAuthenticated();

  // User must have valid token AND be authenticated
  if (hasToken && isAuthenticated) {
    return true;
  }

  // If not authenticated, clear any stale tokens and redirect to login
  if (!isAuthenticated && tokenService.hasToken()) {
    tokenService.removeTokens();
  }

  // Prevent redirect loop - don't set returnUrl if already on login page
  const returnUrl = state.url.startsWith('/auth/login') ? '/' : state.url.split('?')[0];
  
  // Store the attempted URL for redirecting after login
  return router.createUrlTree(['/auth/login'], {
    queryParams: { returnUrl }
  });
};

